import React, { Component } from 'react'

export default class popularAreaInDubai extends Component {
    render() {
        return (
            <section className="section-place-panel">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="section-title text-center">Popular Areas in Dubai</h2>
                        </div>
                    </div>
                    <div className="row row-place-panel">
                        <div className="col-lg-6">
                            <div className="row">
                            <div className="col-md-6">
                                <div className="place-panel place-panel-v-xl">
                                    <a href="#">
                                        <div className="panel-media"><img src="assets/img/place-media-v-xl-1.jpg" alt="media" /></div>
                                        <div className="overlay">
                                        <h5>Downtown Dubai</h5>
                                        <p>Home to the world’s tallest tower and biggest mall</p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="place-panel place-panel-sm">
                                    <a href="#">
                                        <div className="panel-media"><img src="assets/img/place-media-sm-1.jpg" alt="media" /></div>
                                        <div className="overlay">
                                        <h5>Downtown Dubai</h5>
                                        <p>Home to the world’s tallest tower and biggest mall</p>
                                        </div>
                                    </a>
                                </div>
                                <div className="place-panel place-panel-sm">
                                    <a href="#">
                                        <div className="panel-media"><img src="assets/img/place-media-sm-2.jpg" alt="media" /></div>
                                        <div className="overlay">
                                        <h5>Downtown Dubai</h5>
                                        <p>Home to the world’s tallest tower and biggest mall</p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                            <div className="col-md-6">
                                <div className="place-panel place-panel-v-xl">
                                    <a href="#">
                                        <div className="panel-media"><img src="assets/img/place-media-v-xl-2.jpg" alt="media" /></div>
                                        <div className="overlay">
                                        <h5>Downtown Dubai</h5>
                                        <p>Home to the world’s tallest tower and biggest mall</p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="place-panel place-panel-sm">
                                    <a href="#">
                                        <div className="panel-media"><img src="assets/img/place-media-sm-3.jpg" alt="media" /></div>
                                        <div className="overlay">
                                        <h5>Downtown Dubai</h5>
                                        <p>Home to the world’s tallest tower and biggest mall</p>
                                        </div>
                                    </a>
                                </div>
                                <div className="place-panel place-panel-sm">
                                    <a href="#">
                                        <div className="panel-media"><img src="assets/img/place-media-sm-4.jpg" alt="media" /></div>
                                        <div className="overlay">
                                        <h5>Downtown Dubai</h5>
                                        <p>Home to the world’s tallest tower and biggest mall</p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="place-panel place-panel-l-xl">
                            <a href="#">
                                <div className="panel-media"><img src="assets/img/place-media-v-l-1.jpg" alt="media" /></div>
                                <div className="overlay">
                                    <h5>Downtown Dubai</h5>
                                    <p>Home to the world’s tallest tower and biggest mall</p>
                                </div>
                            </a>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="place-panel place-panel-l-xl">
                            <a href="#">
                                <div className="panel-media"><img src="assets/img/place-media-v-l-2.jpg" alt="media" /></div>
                                <div className="overlay">
                                    <h5>Downtown Dubai</h5>
                                    <p>Home to the world’s tallest tower and biggest mall</p>
                                </div>
                            </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
